export const DateFormat = {
    Default: 'MM-DD-YYYY HH:mm:ss',
    Date: ' DD MMM YYYY',
};
